import React, { Component } from 'react';
import Relay from 'react-relay';
import abExperiments from '../../../global/abExperiments.es';
import { Connected as ItemCTAButtons } from '../../../components/ItemActionButtons/ItemCTAButtons';

class ItemCTAButtonsWrapper extends Component {

    constructor() {
        super();

        this.state = {
            tradeMakeOfferCTATestRunning: false,
            makeOfferPurchaseSwapTestRunning: false
        };
    }

    componentDidMount() {
        const { tradeMakeOfferCTA, makeOfferPurchaseSwap } = abExperiments;
        if (tradeMakeOfferCTA) {
            tradeMakeOfferCTA.then(() => {
                this.setState({tradeMakeOfferCTATestRunning: true});
            });
        }
        if (makeOfferPurchaseSwap) {
            makeOfferPurchaseSwap.then(() => {
                this.setState({makeOfferPurchaseSwapTestRunning: true});
            });
        }
    }

    render() {
        const { tradeMakeOfferCTATestRunning, makeOfferPurchaseSwapTestRunning } = this.state;
        const itemCTAButtonsProps = {
            ...this.props,
            tradeMakeOfferCTATestRunning,
            makeOfferPurchaseSwapTestRunning
        };
        return <ItemCTAButtons {...itemCTAButtonsProps} />;
    }
};

export default Relay.createContainer(ItemCTAButtonsWrapper, {
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                ${ItemCTAButtons.getFragment('user')}
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/ItemCTAButtonsWrapper.jsx